(() => {
  const classes = {
    section: 'js-info-tabs',
    tabTitle: 'js-info-tabs__tab-title',
    tabContent: 'js-info-tabs__tab-content',
    active: 'active'
  };
  const infoTabs = document.querySelectorAll(`.${classes.section}`);
  infoTabs.forEach(section => {
    section.classList.remove(classes.section);
    const titles = Array.from(section.querySelectorAll(`.${classes.tabTitle}`));
    let activeTitle = titles.find(title => title.classList.contains(classes.active));
    let activeContent = section.querySelector(`.${classes.tabContent}.${classes.active}`);
    titles.forEach(title => {
      title.addEventListener('click', () => {
        var _activeTitle, _activeContent;

        const contentId = title.dataset.tabContentId;
        if (!contentId) return;
        const content = document.querySelector(`#${contentId}`);
        if (!content) return;
        (_activeTitle = activeTitle) === null || _activeTitle === void 0 ? void 0 : _activeTitle.classList.remove(classes.active);
        (_activeContent = activeContent) === null || _activeContent === void 0 ? void 0 : _activeContent.classList.remove(classes.active);
        title.classList.add(classes.active);
        content.classList.add(classes.active);
        activeTitle = title;
        activeContent = content;
      });
    });
  });
})();
